import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ep_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;

export const LOGO_URL = "/logo.png";
export const HERO_VIDEO = "https://videos.pexels.com/video-files/3205720/3205720-uhd_2560_1440_25fps.mp4";
export const HERO_FALLBACK = "https://images.pexels.com/photos/31953126/pexels-photo-31953126.jpeg";

export const CITIES = [
  { slug: "toronto", name: "Toronto", country: "Canada" },
  { slug: "brampton", name: "Brampton", country: "Canada" },
  { slug: "mississauga", name: "Mississauga", country: "Canada" },
  { slug: "vaughan", name: "Vaughan", country: "Canada" },
  { slug: "markham", name: "Markham", country: "Canada" },
  { slug: "ottawa", name: "Ottawa", country: "Canada" },
  { slug: "montreal", name: "Montreal", country: "Canada" },
  { slug: "vancouver", name: "Vancouver", country: "Canada" },
  { slug: "calgary", name: "Calgary", country: "Canada" },
  { slug: "edmonton", name: "Edmonton", country: "Canada" },
  { slug: "winnipeg", name: "Winnipeg", country: "Canada" },
  { slug: "new-york", name: "New York", country: "USA" },
  { slug: "chicago", name: "Chicago", country: "USA" },
  { slug: "los-angeles", name: "Los Angeles", country: "USA" },
  { slug: "miami", name: "Miami", country: "USA" },
  { slug: "dallas", name: "Dallas", country: "USA" },
  { slug: "seattle", name: "Seattle", country: "USA" },
];

export const SERVICES = [
  { slug: "wedding-photography", name: "Wedding Photography",
    tagline: "Photographs that capture how your day felt — not just how it looked.",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1600&q=80" },
  { slug: "wedding-videography", name: "Wedding Films",
    tagline: "Films that bring you back to the feelings of your wedding day.",
    image: "https://images.unsplash.com/photo-1580824456266-c578703e13da?auto=format&fit=crop&w=1600&q=80" },
  { slug: "engagement-sessions", name: "Engagement Sessions",
    tagline: "A relaxed afternoon to celebrate this season of your love.",
    image: "https://images.pexels.com/photos/33051851/pexels-photo-33051851.jpeg?auto=compress&w=1600" },
  { slug: "destination-weddings", name: "Destination Weddings",
    tagline: "Travelling with you to wherever your story unfolds.",
    image: "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?auto=format&fit=crop&w=1600&q=80" },
  { slug: "drone-coverage", name: "Drone Coverage",
    tagline: "Aerial moments that show the bigger picture of your day.",
    image: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1600&q=80" },
  { slug: "content-creation", name: "Social Media Content",
    tagline: "Same-day reels you can share before your guests leave.",
    image: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1600&q=80" },
  { slug: "luxury-wedding-coverage", name: "Full-Day Coverage",
    tagline: "Quiet, thoughtful coverage from morning prep to your last dance.",
    image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?auto=format&fit=crop&w=1600&q=80" },
];
